<template>
  <div id="headerWrapper">
    <div
      style="border-bottom: 1px solid rgba(255, 255, 255, 0.25); display: flex"
    >
      <div class="header">
        <div class="header-logo" @click="homePath()">
          <img src="@/assets/image/oh.png" />
          <div class="name">鸥航数字科技</div>
          <!-- <div
            class="loginBox"
            @click="submitted()"
            v-if="areSignedIn == false"
          >
            登录
          </div> -->
        </div>
        <div class="leftBox">
          <div class="web-nav" style="opacity: 1; right: 200px">
            <ul>
              <li
                class="lii"
                v-for="(item, index) in titleList"
                :key="index"
                @click.stop="path(item, index)"
                @mouseover="mouseoverTitle(item, index)"
                @mouseout="mouseleaveTitle(item, index)"
              >
                <a>
                  <a
                    class="active1"
                    style="
                      color: #2b2e2e;
                      font-weight: bolder;
                      text-align: center;
                    "
                  >
                    {{ item.title }}
                    <div
                      class="link"
                      :style="
                        pathRoutin.routinPath == item.path
                          ? 'display:block !important;'
                          : ''
                      "
                    ></div
                  ></a>
                </a>
                <div class="subList">
                  <div class="ulList" style="margin-left: 0px">
                    <div
                      style="float: left; margin-left: 0px; height: 60px"
                      v-for="(ite, inde) in item.sonList"
                      :key="inde"
                      @click.stop="child(item, index, inde)"
                    >
                      <a
                        style="
                          color: #6a6c6c;
                          width: 300px;
                          margin-left: -69px;
                          padding: 0px 20px;
                          display: inline-block;
                        "
                        >{{ ite.title }}</a
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="subDiv">
            <div style="max-width: 1200px; margin: auto">
              <!-- <div class="header-logo" @click="homePath()">
                <img src="@/assets/image/oh.png" />
                <div class="name">鸥航数字科技</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleList: [
        {
          title: "关于我们",
          path: "/aboutUs",
        },
        {
          title: "产品服务",
          path: "/productsAndServices",
          sonList: [
            { title: "网站建设", path: "/productsAndServices" },
            { title: "微信开发", path: "/productsAndServices" },
            { title: "系统定制", path: "/productsAndServices" },
            { title: "运营托管", path: "/productsAndServices" },
          ],
        },
        { title: "联系我们", path: "/contactUs" },
      ],
      displayList: [],
      selectKey: null,
      pathRoutin: { routinPath: "" },
      areSignedIn: false,
    };
  },
  created() {
    if (sessionStorage.pathRoutin) {
      this.pathRoutin = JSON.parse(sessionStorage.pathRoutin);
    }
    if (sessionStorage.areSignedIn) {
      this.areSignedIn = true;

      this.titleList = [
        {
          title: "关于我们",
          path: "/aboutUs",
        },
        {
          title: "产品服务",
          path: "/productsAndServices",
          sonList: [
            { title: "网站建设", path: "/productsAndServices" },
            { title: "微信开发", path: "/productsAndServices" },
            { title: "系统定制", path: "/productsAndServices" },
            { title: "运营托管", path: "/productsAndServices" },
          ],
        },
        {
          title: "产品中心",
          path: "/solution",
          sonList: [
            { title: "云鸥协同办公系统", path: "/solution" },
            {
              title: "点餐系统",
              path: "admin",
              url: "http://scan.ohdt.top/workbench",
            },
          ],
        },
        { title: "联系我们", path: "/contactUs" },
      ];
    } else {
      this.areSignedIn = false;
      this.titleList = [
        {
          title: "关于我们",
          path: "/aboutUs",
        },
        {
          title: "产品服务",
          path: "/productsAndServices",
          sonList: [
            { title: "网站建设", path: "/productsAndServices" },
            { title: "微信开发", path: "/productsAndServices" },
            { title: "系统定制", path: "/productsAndServices" },
            { title: "运营托管", path: "/productsAndServices" },
          ],
        },
        // {
        //   title: "产品中心",
        //   path: "/solution",
        //   sonList: [{ title: "云鸥协同办公系统", path: "/solution" }],
        // },
        { title: "联系我们", path: "/contactUs" },
      ];
    }
  },
  methods: {
    homePath() {
      this.$router.replace("/");
      sessionStorage.removeItem("pathRoutin");
    },
    path(item, index) {
      console.info("点击导航");
      console.info(item);
      // if (item.sonList) {
      // } else {
      sessionStorage.setItem(
        "pathRoutin",
        JSON.stringify({
          routinPath: item.path,
          path: item.path,
          pathIndex: index,
        })
      );
      // }
      this.pathRoutin = {
        routinPath: item.path,
        path: item.path,
        pathIndex: index,
      };
      this.$router.push({
        path: "/index/PageBlank",
        query: { path: item.path },
      });
    },
    child(item, index, inde) {
      if (item.sonList[inde].path) {
        this.$router.push({
          path: "/index/PageBlank",
          query: { path: item.sonList[inde].path },
        });
        sessionStorage.setItem(
          "pathRoutin",
          JSON.stringify({
            routinPath: item.path,
            path: item.sonList[inde].path,
            pathIndex: index,
            inde: inde,
          })
        );
        // }
      }
    },
    openNew(key, keyPath) {
      if (key) {
        window.open(key, "_search");
      }
    },
    // 鼠标经过
    mouseoverTitle(i, k) {
      if (i.sonList) {
        var subDivL = document.getElementsByClassName("subDiv");
        subDivL[0].style.display = "block";
      }
    },
    // 鼠标离开
    mouseleaveTitle(i, k) {
      if (i.sonList) {
        var subDivL = document.getElementsByClassName("subDiv");
        subDivL[0].style.display = "none";
      }
    },
    submitted() {
      this.$router.replace("/login");
    },
  },
};
</script>
<style scoped>
#headerWrapper {
  background: #fff;
  height: 64px;
  position: fixed;
  top: 0;
  z-index: 10000;
  width: 100%;
  transition: background 0.3s cubic-bezier(0.215, 0.61, 0.355, 1),
    border 0.45s cubic-bezier(0.215, 0.61, 0.355, 1);
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
}
#headerWrapper .header {
  width: 100%;
  /* padding: 0 4%; */
  max-width: 1200px;
  margin: auto;
  position: relative;
  transition: transform 0.45s cubic-bezier(0.215, 0.61, 0.355, 1);
  text-align: left;
  box-sizing: border-box;
  display: inline-block;
}
#headerWrapper .header .header-logo {
  margin: 20px 0px;
  height: 23px;
  z-index: 0;
  position: relative;
  opacity: 1;
  display: flex;
  align-items: center;
}
.loginBox {
  position: absolute;
  color: #020813 !important;
  right: 60px;
  font-size: 12px;
  background: #1a325d;
  color: #fff !important;
  padding: 7px 20px;
  border-radius: 20px;
}
#headerWrapper .header .header-logo img {
  width: 55px;
  height: 35px;
}
#headerWrapper .header .header-logo .name {
  color: #014295;
  font-weight: bolder;
  font-size: 17px;
  line-height: 23px;
  transition: all 0.5s ease-in-out;
  display: inline-block;
}
.leftBox:hover .web-nav ul li .active1 {
  /* color: #014295 !important; */
}
.leftBox:hover .web-nav ul li:hover .active1 .link {
  display: block !important;
}
.leftBox:hover .web-nav ul li:hover .subList {
  display: block !important;
}
/* .leftBox:hover .subDiv {
  display: block;
} */

.web-nav {
  line-height: 64px;
  position: absolute;
  right: 0;
  top: 0;
  height: 64px;
}
.web-nav a,
.web-nav button {
  width: 100%;
  font-size: 14px;
  display: block;
  color: #8c9bb3;
  letter-spacing: 0.5px;
  transition: color 0.45s cubic-bezier(0.215, 0.61, 0.355, 1),
    border-color 0.45s cubic-bezier(0.215, 0.61, 0.355, 1);
  text-decoration: none;
  z-index: 999;
}
.web-nav .active1 {
  position: relative;
  text-decoration: none;
}
.web-nav .active1 .link {
  height: 4px;
  width: 100%;
  background: #4285f4;
  position: absolute;
  bottom: 14px;
  display: none !important;

  animation: all 1s;
}
@keyframes all {
  0% {
    width: 0%;
  }
  60% {
    width: 100%;
  }
}
.active1:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 15px;
  height: 4px;
  width: 100%;
  background: #4285f4;
  transform: scale(0);
  transition: all 0.3s;
}
.web-nav ul {
  display: inline-block;
  position: relative;
}
.web-nav ul li {
  float: left;
  padding: 0 24px;
  transition: margin 0.3s;
  z-index: 9999;
}

.web-nav ul a,
.web-nav ul .lang-btn button {
  border-color: #fff;
}
.web-nav .subList {
  width: 100px;
  left: 50%;
  margin-left: -50px;
  display: none;
  text-align: center;
  animation: sub 1s;
}
@keyframes sub {
  0% {
    width: 20px;
  }
  60% {
    width: 100px;
  }
}
.web-nav .subList .ulList {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 250px;
}
.web-nav .subList .ulList a:hover {
  color: black !important;
}
.subDiv {
  display: none;
  width: 3000px;
  margin-left: -1000px;
  height: 350px;
  margin-top: -64px;
  background: #fff;
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.05);
  animation: animation 1s;
}
.subDiv .header-logo {
  position: absolute !important;
  top: 0;
  left: 0;
  margin-left: 59px !important;
  margin-top: 20px !important;
}
.subDiv .header-logo .name {
  color: #014295 !important;
}
@keyframes animation {
  0% {
    height: 70px;
  }
  60% {
    height: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topTags/topTags.vue